// Google Analytics 4 via gtag (loaded in index.html with send_page_view: false,
// so SPA navigations are reported here instead of only the initial load).
function gtag() {
  if (typeof window.gtag === 'function') {
    window.gtag(...arguments);
  }
}

export function trackPageview(path) {
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });
}

export function trackEvent({ category, action, label }) {
  gtag('event', action, { event_category: category, event_label: label });
}
